import React, { useState } from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import DeliveryModal from './DeliveryModal'
import {
  hero,
  heroText,
  mobileHero,
  mobileHeroText,
  orderDeliveryButton,
} from 'images'

export default () => {
  const [showModal, setShowModal] = useState(false)
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
        >
          {/*<Header />*/}
          <CFView
            mt="30px"
            column
            alignCenter
            justifyEnd
            w="100%"
            textCenter
            mb="10vh"
          >
            <CFImage
              w="100%"
              src={mobileHeroText}
              alt="Wara Delta hero text"
              zIndex={98}
            />
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
            <CFView hover onClick={() => setShowModal(true)} column center>
              <CFImage
                w="95%"
                maxWidth="320px"
                src={orderDeliveryButton}
                alt="Order delivery"
              />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column center ml="3%">
            <CFImage
              w="52vw"
              maxWidth="630px"
              src={heroText}
              alt="Wara Delta hero text"
              zIndex={98}
            />
            <CFView pulsate mt="45px">
              <OrderPickupButton />
            </CFView>
            <CFView hover onClick={() => setShowModal(true)}>
              <CFImage
                w="100%"
                maxWidth="325px"
                src={orderDeliveryButton}
                alt="Order delivery"
              />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <DeliveryModal
        showModal={showModal}
        onRequestClose={() => setShowModal(false)}
      />
    </CFView>
  )
}
